import o from "react";
import l from "classnames";
import { T as d } from "./index-Dd-4N6BE.es.js";
import './Body.css';const m = "Body-module__cardBody___2gIiZ", s = "Body-module__lineClamp___DzzoE", a = {
  cardBody: m,
  lineClamp: s
}, r = ({
  children: t,
  maxLines: e = void 0
}) => /* @__PURE__ */ o.createElement("div", { className: a.cardBody }, /* @__PURE__ */ o.createElement(d.Body, { responsive: !0 }, /* @__PURE__ */ o.createElement(
  "span",
  {
    className: l(e && a.lineClamp),
    style: e ? { WebkitLineClamp: e } : {}
  },
  t
)));
r.displayName = "Body";
export {
  r as B
};
